module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0006.jpg?v=2b52f844";